import script from "./FormBase.vue?vue&type=script&setup=true&lang=js"
export * from "./FormBase.vue?vue&type=script&setup=true&lang=js"

import "./FormBase.vue?vue&type=style&index=0&id=3d346b04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d346b04"]])

export default __exports__